var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',_vm._g(_vm._b({staticClass:"button",class:_vm.pointClass,attrs:{"loading-size":"32","type":_vm.type}},'van-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }